export const environment = {
  production: true,
  port: 'wccfe-qa.corp.hpicloud.net'
};
